import React, { Component } from "react";
import "./Card.css"

class CardBody extends Component {
    render() {
      return <div className="card__body">{this.props.children}</div>;
    }
}

export default class Card extends Component {
  static Body = CardBody;
  render() {
    return <div className="card">{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Card.js